import { interpretarAnimo, type Tono } from './animo'
import type { Metadatos } from './consultas'

/**
 * El estado de animo, con color **y** texto. Nunca solo color: quien no
 * distingue el verde del rojo se quedaria sin el dato, y un punto de color a
 * secas no dice si el 7 es de 10 o de 5. Y nunca con emojis, que es como lo
 * pintaba el panel viejo.
 */
const CLASES: Record<Tono, string> = {
  positivo: 'bg-positivo-fondo text-positivo-tinta ring-positivo-anillo',
  neutro: 'bg-neutro-fondo text-neutro-tinta ring-neutro-anillo',
  negativo: 'bg-negativo-fondo text-negativo-tinta ring-negativo-anillo',
}

const PUNTO: Record<Tono, string> = {
  positivo: 'bg-positivo-punto',
  neutro: 'bg-neutro-punto',
  negativo: 'bg-negativo-punto',
}

interface Props {
  meta?: Metadatos | null
}

export function InsigniaAnimo({ meta }: Props) {
  const animo = interpretarAnimo(meta)
  if (!animo) return null

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${CLASES[animo.tono]}`}
    >
      <span aria-hidden="true" className={`size-1.5 shrink-0 rounded-full ${PUNTO[animo.tono]}`} />
      {animo.texto}
    </span>
  )
}
